import React from 'react'
import { IconButton, Icon } from 'rsuite'

export default function EditButton({
  onClick,
  children = 'แก้ไข',
  disabled,
  icon = 'edit',
  className = 'rs-btn-ghost-edit',
  size,
  ...props
}) {
  return (
    <IconButton
      size={size}
      onClick={onClick}
      appearance="ghost"
      className={className}
      style={{
        marginRight: 10,
        marginBottom: 10,
      }}
      icon={<Icon icon={icon} className="bt-gost-icon-radius-edit" />}
      disabled={disabled}
      {...props}
    >
      {children}
    </IconButton>
  )
}
